import { Box, Grid2, Paper } from "@mui/material";
import React from "react";
import LanguageSelection from "Components/Common/LanguageSelection";
import AuthBackground from "Assets/Backgrounds/auth-background.svg";
import RightBackground from "Assets/Backgrounds/right-background.svg";
import RenderLogo from "Components/Common/RenderLogo";
import zIndex from "@mui/material/styles/zIndex";

const styles = (theme) => ({
  height: "100vh",
  display: "flex",
  position: "relative",
  "& .logo": {
    position: "absolute",
    top: "30px",
    left: "30px",
    zIndex: 1
  },
  "& .language": {
    position: "absolute",
    top: "30px",
    right: "30px",
    zIndex: 1
  },
  "& .left": {
    backgroundImage: `url(${AuthBackground})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "50%",
    height: "100%",
    transform: theme.direction === 'rtl' ? "scaleX(-1)" : "none",
  },
  // "& .right": {
  //   backgroundImage: `url(${RightBackground})`,
  //   backgroundRepeat: "no-repeat",
  //   width: "50%",
  //   height: "100%",
  //   backgroundPositionX: "right",
  //   backgroundPositionY: "bottom",
  // },

  "& .right": {
    width: "50%",
    height: "100%",
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .right-bg": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundImage: `url(${RightBackground})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: `${theme.direction === "rtl" ? "left" : "right"} bottom`,
    transform: theme.direction === "rtl" ? "scaleX(-1)" : "none",
    zIndex: 0,
  },
  "& .right-content": {
    position: "relative",
    zIndex: 1,
    width: "100%", // adjust as needed
  },
});

const AuthWrapper = ({ children }) => {

  return (
    <Grid2 sx={(theme) => styles(theme)}>
      <Box className="logo">
        <RenderLogo type="white" />
      </Box>
      <Box className="language">
        <LanguageSelection />
      </Box>
      
      <Grid2 className="left" />
      {/* <Paper elevation={0} className="right">
        {children}
      </Paper> */}
      <Paper elevation={0} className="right">
        <Box className="right-bg" />
        <Box className="right-content">
          {children}
        </Box>
      </Paper>
    </Grid2>
  );
};

export default AuthWrapper;
